import { render, staticRenderFns } from "./ChooseClient.vue?vue&type=template&id=01495dcd&scoped=true&"
import script from "./ChooseClient.vue?vue&type=script&lang=ts&"
export * from "./ChooseClient.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseClient.vue?vue&type=style&index=0&id=01495dcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01495dcd",
  null
  
)

export default component.exports